const PREFIX = 'TSMED-AircraftDrawerWeather';

export const aircraftDrawerLocationClasses = {
  tabsHeader: `${PREFIX}-tabsHeader`,
  tabLabel: `${PREFIX}-tabLabel`,
  flightCategoryHeader: `${PREFIX}-flightCategoryHeader`,
  flightCategory: `${PREFIX}-flightCategory`,
  categoryIcon: `${PREFIX}-categoryIcon`,
  categoryLabel: `${PREFIX}-categoryLabel`,
  categoryTime: `${PREFIX}-categoryTime`,
  header: `${PREFIX}-header`,
  body: `${PREFIX}-body`,
  raw: `${PREFIX}-raw`,
  rawItem: `${PREFIX}-rawItem`,
  forecasts: `${PREFIX}-forecasts`,
  forecast: `${PREFIX}-forecast`,
  forecastTime: `${PREFIX}-forecastTime`,
  forecastFlightCategory: `${PREFIX}-forecastFlightCategory`,
  forecastFields: `${PREFIX}-forecastFields`,
  forecastField: `${PREFIX}-forecastField`,
  forecastFieldLabel: `${PREFIX}-forecastFieldLabel`,
  forecastFieldValue: `${PREFIX}-forecastFieldValue`,
};
